var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDishes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe 1228",
    clipPath: "url(#clip0_321_686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe 1228_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5322",
    d: "M26.6614 9.40856C26.6614 7.55075 25.4395 6.04468 23.9315 6.04468C22.4235 6.04468 21.2026 7.55075 21.2026 9.40856C21.1871 9.95775 21.2979 10.5031 21.5262 11.0023C21.7546 11.5014 22.0944 11.9409 22.5192 12.2866C22.6843 12.4123 22.8164 12.5766 22.904 12.7652C22.9916 12.9538 23.0321 13.1611 23.0219 13.369L22.67 21.7176C22.6616 21.8883 22.687 22.059 22.7449 22.2198C22.8027 22.3805 22.8918 22.5281 23.007 22.6539C23.1222 22.7797 23.2611 22.8812 23.4156 22.9525C23.5702 23.0237 23.7374 23.0634 23.9073 23.0691C24.0803 23.0726 24.2522 23.0404 24.4122 22.9745C24.5723 22.9085 24.7173 22.8103 24.8381 22.6858C24.9588 22.5612 25.0529 22.4131 25.1145 22.2506C25.176 22.0881 25.2037 21.9146 25.1959 21.7409L24.8431 13.3652C24.8329 13.1572 24.8733 12.95 24.9609 12.7613C25.0485 12.5727 25.1806 12.4084 25.3457 12.2827C25.7699 11.9374 26.1092 11.4984 26.3373 11C26.5655 10.5016 26.6763 9.95702 26.6614 9.40856Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5338",
    d: "M19.8293 16.9952L20.0226 21.5688C20.03 21.7444 20.001 21.9196 19.9376 22.0834C19.8741 22.2472 19.7776 22.396 19.654 22.5203C19.5305 22.6447 19.3826 22.742 19.2198 22.806C19.0569 22.87 18.8826 22.8993 18.7079 22.8922C18.3683 22.8721 18.0505 22.7178 17.8237 22.4629C17.5969 22.208 17.4797 21.8733 17.4977 21.5319L17.8476 13.2378C17.8605 12.9975 17.8061 12.7584 17.6906 12.5477C17.5751 12.3369 17.4031 12.163 17.1941 12.0456C16.9285 11.9022 16.7065 11.6892 16.5518 11.4291C16.3971 11.169 16.3154 10.8717 16.3154 10.5686V7.03859C16.3154 6.82135 16.4013 6.613 16.5541 6.45939C16.7069 6.30577 16.9142 6.21948 17.1303 6.21948C17.3465 6.21948 17.5537 6.30577 17.7066 6.45939C17.8594 6.613 17.9452 6.82135 17.9452 7.03859C17.9452 6.82135 18.0311 6.613 18.1839 6.45939C18.3367 6.30577 18.544 6.21948 18.7601 6.21948C18.9763 6.21948 19.1835 6.30577 19.3364 6.45939C19.4892 6.613 19.575 6.82135 19.575 7.03859C19.575 6.82135 19.6609 6.613 19.8137 6.45939C19.9665 6.30577 20.1738 6.21948 20.3899 6.21948C20.6061 6.21948 20.8133 6.30577 20.9662 6.45939C21.119 6.613 21.2048 6.82135 21.2048 7.03859V10.5686C21.2049 10.8717 21.1232 11.169 20.9685 11.4291C20.8137 11.6892 20.5917 11.9022 20.3261 12.0456C20.117 12.1628 19.9448 12.3367 19.8291 12.5475C19.7134 12.7583 19.6589 12.9974 19.6717 13.2378L19.7258 14.5301",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5342",
    d: "M4.85362 8.19983C4.23175 9.36884 3.90729 10.6744 3.90919 12C3.90919 14.1404 4.75511 16.1932 6.26087 17.7068C7.76663 19.2203 9.80887 20.0706 11.9383 20.0706C13.0035 20.072 14.0583 19.8597 15.0408 19.446C16.0233 19.0324 16.9138 18.4258 17.66 17.6619",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5346",
    d: "M18.0077 6.71714C17.2547 5.84112 16.3225 5.13863 15.2749 4.65755C14.2273 4.17647 13.0888 3.92813 11.937 3.92945C9.85315 3.92665 7.85037 4.74095 6.35449 6.19925",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5350",
    d: "M19.9727 20.4098C21.3108 19.1193 22.3218 17.5254 22.921 15.7614",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5354",
    d: "M22.2852 6.72487C21.3157 4.80448 19.8361 3.19147 18.0104 2.06467C16.1847 0.937857 14.0842 0.341275 11.9418 0.341064C8.8653 0.341064 5.91481 1.56952 3.73938 3.75617C1.56396 5.94283 0.341797 8.90858 0.341797 12.001C0.341797 15.0934 1.56396 18.0591 3.73938 20.2458C5.91481 22.4325 8.8653 23.6609 11.9418 23.6609C13.9348 23.664 15.8946 23.1485 17.6307 22.1645",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_321_686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDishes);
export default __webpack_public_path__ + "static/media/dishes.960668e941009797de3a5b3cf994e057.svg";
export { ForwardRef as ReactComponent };